// extracted by mini-css-extract-plugin
export default {"inner":"Loader_inner__ym0q-","grow":"Loader_grow__6COqn","outer":"Loader_outer__3s-H-"};